export const AggregatePerformanceMappers = {
  toGraphData: classificationMetric => ({
    classificationId: classificationMetric.Classification.Id,
    classificationMetricName: classificationMetric.Classification.ClassificationMeasurementName,
    metricCalculationName: classificationMetric.MeasurementCalculationName,
    measurementUnit: classificationMetric.MeasurementUnit,
    goodPerformanceIndicator: classificationMetric.GoodPerformanceIndicator,
    numberOfSites: classificationMetric.NumberOfSites,
    expirationData: classificationMetric.ExpirationData
      ? {
          year: classificationMetric.ExpirationData.Year,
          quarter: classificationMetric.ExpirationData.Quarter
        }
      : null,
    quarterlyData: classificationMetric.QuarterlyData.map(item => ({
      quarter: item.Quarter.DisplayName,
      year: item.Quarter.Year,
      quarterNum: item.Quarter.QuarterNum,
      average: item.Average,
      median: item.Median,
      count: item.Count
    }))
  })
};
